import React from 'react';
import { CheckCircle } from 'lucide-react';

export interface FeatureBadge {
  label: string;
}

export const FeatureBadgeRow: React.FC<{ badges: FeatureBadge[] }> = ({ badges }) => (
  <>
    {badges.map(b => (
      <span key={b.label} className="io-site-badge">
        <CheckCircle size={16} aria-hidden />
        <span>{b.label}</span>
      </span>
    ))}
  </>
);
